// Mock data for Adastra Restaurant Website
import { getImageUrl } from '../config/cdn';

export const restaurantInfo = {
  name: "ADASTRA",
  tagline: "Cocina Cubana Moderna",
  description: "Una experiencia gastronómica única donde la tradición cubana se encuentra con la innovación culinaria contemporánea",
  phone: "+5363518498",
  whatsapp: "+5363518498",
  email: "reservas@adastra.cu",
  address: "Obispo 255 entre Cuba y Aguiar, Habana Vieja",
  hours: {
    weekdays: "12:00 AM - 12:00 PM",
    weekend: "12:00 AM - 12:00 PM",
    closed: "Lunes"
  },
  social: {
    instagram: "@adastra_habana",
    facebook: "AdastraRestaurante",
    tripadvisor: "adastra-restaurant"
  }
};

export const menuCategories = [
  { id: 'entrantes-frios', name: 'Entrantes Fríos', icon: '🥗' },
  { id: 'entrantes-calientes', name: 'Entrantes Calientes', icon: '🔥' },
  { id: 'carnes', name: 'Carnes', icon: '🥩' },
  { id: 'pastas', name: 'Pastas', icon: '🍝' },
  { id: 'risottos', name: 'Risottos', icon: '🍚' },
  { id: 'pescados-mariscos', name: 'Pescados y Mariscos', icon: '🐟' },
  { id: 'guarniciones', name: 'Guarniciones', icon: '🥬' },
  { id: 'postres', name: 'Postres', icon: '🍰' }
];

export const menuItems = [
  // === ENTRANTES FRÍOS ===
  {
    id: 1,
    name: "Pimiento Piquillo",
    category: "entrantes-frios",
    price: 3200,
    weight: "50g",
    description: "Piquillo pepper, parmesan cheese, balsamic and olive oil, tuna",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pimientos Piquillos 2.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Piquillos.jpg"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },
  {
    id: 2,
    name: "Tapas de Bodega",
    category: "entrantes-frios",
    price: 6400,
    weight: "300g",
    description: "Serrano ham board with variety of cheeses and olives in oil",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Tabla Bodega.png"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 3,
    name: "Ceviche de Pescado",
    category: "entrantes-frios",
    price: 3000,
    weight: "100g",
    description: "Fresh combination of fish marinated in lime juice, mixed with onion, cilantro, chili, and spices",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ceviche de Pescado.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ceviche de Pescado con Vino Blanco.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ceviche de pescado 2.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: true
  },
  {
    id: 4,
    name: "Carpaccio de Pulpo",
    category: "entrantes-frios",
    price: 6200,
    weight: "80g",
    description: "Octopus carpaccio with Mediterranean flavors",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Carpaccio de Pulpo Close up.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Carpaccio de pulpo.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Carpaccio de Pulpo 2.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 5,
    name: "Ensalada Terránea",
    category: "entrantes-frios",
    price: 3000,
    weight: "150g",
    description: "Assorted vegetables, cheese, vinaigrette, black and green olives",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ensalada Terranea.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ensalada De estacion.jpg"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 6,
    name: "Carpaccio de Res",
    category: "entrantes-frios",
    price: 5600,
    weight: "100g",
    description: "Thin slices of tender beef, drizzled with olive oil, lemon, capers, and fresh herbs for a refreshing flavor",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Carpaccio de res.png"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },
  {
    id: 7,
    name: "Steak Tartar",
    category: "entrantes-frios",
    price: 5500,
    weight: "80g",
    description: "Hand-chopped beef seasoned with mustard, capers, onion, and egg yolk",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Steak Tartar.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Steak tartar 2.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },

  // === ENTRANTES CALIENTES ===
  {
    id: 8,
    name: "Croquetas",
    category: "entrantes-calientes",
    price: 1800,
    weight: "unidad",
    description: "Our crispy croquettes are creamy and well-seasoned",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Croquetas.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Croquetas 2.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Croquetas 3.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Croqueta.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 9,
    name: "Gambón en Olivo",
    category: "entrantes-calientes",
    price: 5800,
    weight: "100g",
    description: "Jumbo shrimp sautéed in aromatic olive oil infused with fresh garlic",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Gambon al Olivo.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 10,
    name: "Crema al Día",
    category: "entrantes-calientes",
    price: 1700,
    weight: "250ml",
    description: "A velvety Cuban root vegetable cream with olive oil—pure comfort",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Crema de Calabaza.JPG"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 11,
    name: "Ajiaco Cubano",
    category: "entrantes-calientes",
    price: 3700,
    weight: "250ml",
    description: "Creole stew of beef, pork or chicken with root vegetables and corn in a rich broth",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ajiaco 3.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ajiaco.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ajiaco 1.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },

  // === CARNES ===
  {
    id: 12,
    name: "Cordero ADASTRA",
    category: "carnes",
    price: 4900,
    weight: "200g",
    description: "Slowly baked with rosemary, spices, and a wine reduction for an intense and juicy flavor",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Cordero adastra.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Cordero 2.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 13,
    name: "Cortes de Carnes",
    category: "carnes",
    price: 11000,
    weight: "200-450g",
    description: "Premium beef cuts prepared to perfection",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Corte de Res.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Corte de Res 1.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Corte de res 2.jpg"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },
  {
    id: 14,
    name: "Vaca Frita",
    category: "carnes",
    price: 3200,
    weight: "200g",
    description: "Juicy shredded beef, perfectly seared with garlic, onion, and a touch of lime",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ropa Vieja de Cordero 2.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 15,
    name: "Pollo con Salsa de Champiñones",
    category: "carnes",
    price: 3200,
    weight: "200g",
    description: "Juicy chicken breast served with a creamy mushroom sauce, garlic, and fresh herbs",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pollo con Salsa de Champiñones.png"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },
  {
    id: 16,
    name: "Cerdo Criollo & Tamal en Cazuela",
    category: "carnes",
    price: 3600,
    weight: "150g",
    description: "Creole pork with tamale in casserole",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Cerdo en Tamal en casuela.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Cerdo con tamal en cazuela.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Cerdo con tamal en cazuela 2.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 17,
    name: "Estofado de Carne",
    category: "carnes",
    price: 4200,
    weight: "200g",
    description: "Tender beef chunks slow-cooked in a tomato sauce with peppers, garlic, and spices",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Estofado de Carne.JPG"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },
  {
    id: 18,
    name: "Ropa Vieja de Cordero",
    category: "carnes",
    price: 3300,
    weight: "100g",
    description: "A Cuban classic of slow-braised lamb, sautéed with garlic, onions, and peppers, then simmered in rich tomato sauce for deep, savory flavors",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ropa Vieja de Cordero.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 19,
    name: "Menú Kids",
    category: "carnes",
    price: 3300,
    weight: "porción",
    description: "Tender grilled chicken breast, served with crispy seasonal fried root vegetables and soft white rice",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Menu Kids.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Menu Kids 2.JPG"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },

  // === PASTAS ===
  {
    id: 20,
    name: "Pasta Bellahabana",
    category: "pastas",
    price: 6700,
    weight: "100g",
    description: "Pasta with shrimp, mushrooms and truffle oil",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pasta bellaHabana.png"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 21,
    name: "Risotto de Punta de Filete y Boletus",
    category: "pastas",
    price: 6500,
    weight: "250g",
    description: "Risotto with filet tip and boletus mushrooms",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Risotto punta de filete 2.jpeg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 22,
    name: "Raviolis",
    category: "pastas",
    price: 4600,
    weight: "200g",
    description: "Delicious crab or lobster-stuffed ravioli with a smooth homemade tomato sauce, garlic, and basil",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Raviolis.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },

  // === RISOTTOS ===
  {
    id: 23,
    name: "Risotto Funghi Porcini",
    category: "risottos",
    price: 5200,
    weight: "100g",
    description: "Risotto with assorted mushrooms",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Risotto funghi.png"
    ],
    popular: true,
    vegetarian: true,
    spicy: false
  },
  {
    id: 24,
    name: "Risotto Marinero",
    category: "risottos",
    price: 7200,
    weight: "250g",
    description: "A creamy risotto with an exquisite combination of fresh seafood",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Risotto marinero.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },

  // === PESCADOS Y MARISCOS ===
  {
    id: 25,
    name: "Pescado al Grill",
    category: "pescados-mariscos",
    price: 4200,
    weight: "200g",
    description: "Grilled fish with olive oil and vegetables",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pescado al grill.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pescado Grille 2.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 26,
    name: "Pescado Boreal",
    category: "pescados-mariscos",
    price: 5100,
    weight: "200g",
    description: "Fish on a bed of green, basil, butter, lemon and pepper",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pescado Boreal.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pescado Boreal 1.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pescado Boreal 2.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pescado Boreal 3.JPG"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },
  {
    id: 27,
    name: "Langosta Hierro y Madera",
    category: "pescados-mariscos",
    price: 5200,
    weight: "200g",
    description: "Lobster in honor of Varadero made with typical Cuban sauces",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Langosta%20Hierro%20y%20Madera.jpg"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 28,
    name: "Pulpo Mediterráneo",
    category: "pescados-mariscos",
    price: 7500,
    weight: "100g",
    description: "Tender octopus sautéed with fresh basil and aromatic garlic, drizzled with olive oil",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pulpo Mediterraneo 2.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pulpo mediterraneo 3.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pulpo mediterraneo 4.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 29,
    name: "Mariscada para 2 Personas",
    category: "pescados-mariscos",
    price: 12000,
    weight: "400g",
    description: "Variety of fresh seafood spiced with white wine and a smooth butter and lemon sauce. It can also be served with tomato sauce",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Mariscada.JPG"
    ],
    popular: true,
    vegetarian: false,
    spicy: false
  },
  {
    id: 30,
    name: "Langosta Isleña",
    category: "pescados-mariscos",
    price: 5600,
    weight: "200g",
    description: "Delicatessen of Cuban cuisine. Sautéed lobster with pineapple",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Langosta Isleña.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Langosta Isleña 2.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Langosta Isleña 3.JPG"
    ],
    popular: false,
    vegetarian: false,
    spicy: false
  },

  // === GUARNICIONES ===
  {
    id: 31,
    name: "Vianda Fritas",
    category: "guarniciones",
    price: 1400,
    weight: "100g",
    description: "Fried vegetables",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Vianda frita.png",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Vianda Frita 2.png"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 32,
    name: "Arroz Blanco",
    category: "guarniciones",
    price: 1100,
    weight: "100g",
    description: "White rice",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Arroz Blanco.jpg"
    ],
    popular: true,
    vegetarian: true,
    spicy: false
  },
  {
    id: 33,
    name: "Arroz Moro",
    category: "guarniciones",
    price: 1100,
    weight: "100g",
    description: "Moros y Cristianos - rice with black beans",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Arroz Moro.jpg"
    ],
    popular: true,
    vegetarian: true,
    spicy: false
  },
  {
    id: 34,
    name: "Frijoles Negros",
    category: "guarniciones",
    price: 950,
    weight: "100g",
    description: "Black beans",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Frijoles negros.png"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 35,
    name: "Puré de Estación",
    category: "guarniciones",
    price: 1400,
    weight: "100g",
    description: "Root vegetable mash",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pure de vianda.png"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 36,
    name: "Ensalada de Vegetales",
    category: "guarniciones",
    price: 1700,
    weight: "120g",
    description: "Mixed vegetable salad",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Ensalada de Vegetales.png",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/ensalda de Vegetales 1.png"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 37,
    name: "Vegetales al Grill",
    category: "guarniciones",
    price: 1900,
    weight: "120g",
    description: "Grilled vegetables",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Vegetales al Grill.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Vegetales al Grill 1.JPG",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Vegetales al Grill 2.JPG"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 38,
    name: "Pan",
    category: "guarniciones",
    price: 700,
    weight: "1 unidad",
    description: "Fresh bread",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Pan.jpg"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },

  // === POSTRES ===
  {
    id: 39,
    name: "Postres Cubanos Caseros",
    category: "postres",
    price: 1600,
    weight: "porción",
    description: "Traditional homemade Cuban desserts",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Casquitos de Guayaba.jpg",
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Dulce de Frutabomba Cubano 2.JPG"
    ],
    popular: true,
    vegetarian: true,
    spicy: false
  },
  {
    id: 40,
    name: "Tarta de Chocolate",
    category: "postres",
    price: 2600,
    weight: "porción",
    description: "Rich chocolate cake",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Tarta de Chocolate.jpeg"
    ],
    popular: false,
    vegetarian: true,
    spicy: false
  },
  {
    id: 41,
    name: "Cheesecake",
    category: "postres",
    price: 2400,
    weight: "porción",
    description: "Creamy New York style cheesecake",
    images: [
      "https://pub-f7715da643654e03b4e14e82a2790fb1.r2.dev/Chessecake de Limon.JPG"
    ],
    popular: true,
    vegetarian: true,
    spicy: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María Fernández",
    role: "Cliente VIP",
    rating: 5,
    comment: "Una experiencia gastronómica inolvidable. Cada plato es una obra de arte que celebra la auténtica cocina cubana con un toque moderno excepcional.",
    image: "/assets/images/clientes/cliente-cocktail-sonriente.jpg"
  },
  {
    id: 2,
    name: "Carlos Rodriguez",
    role: "Crítico Gastronómico",
    rating: 5,
    comment: "ADASTRA eleva la cocina cubana a nuevas alturas. La fusión de sabores tradicionales con técnicas contemporáneas es absolutamente magistral.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&auto=format&facepad=2.25&faceindex=1&sat=-100"
  },
  {
    id: 3,
    name: "Ana Delgado",
    role: "Chef Internacional",
    rating: 5,
    comment: "Cada visita a ADASTRA es un viaje culinario único. La creatividad del chef y la calidad de los ingredientes crean una sinfonía de sabores perfecta.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&auto=format&facepad=2.25&faceindex=1&sat=-100"
  }
];